import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleShowStatePopUp } from "../../../REDUX/NavbarDropDownToggle/navBarDropToggle";

// import NavDropDownPop from "./NavDropDownPop";

const SearchBox = () => {
  const { SearchStateValue } = useSelector((state) => state.DropDownNav);

  const dispatch = useDispatch();
  return (
    <form className="pt-2 relative mx-auto text-gray-600 w-full px-4">
      <div className="border-2 bg-slate-50 h-14 px-4 pr-16 text-sm w-full rounded-full border-blue-600 flex items-center justify-center gap-3">
        <span>
          <i className="bi bi-search text-xl font-bolder"></i>
        </span>
        <input
          type="search"
          name="search"
          placeholder="Search..."
          className=" bg-transparent h-14 md: text-sm  w-full border-0 focus:outline-none bg-[#007BFF] font-workSans md:text-[18px] placeholder:font-workSans placeholder:font-thin placeholder:text-black"
        />
        <div className="line w-[1px] bg-slate-400  h-[90%]"></div>

        <div className="w-[25%] md:w-[14%] h-full relative">
          <div
            onClick={() => dispatch(toggleShowStatePopUp())}
            className="w-full bg-rd-400 h-full flex items-center justify-betwceeen text-[#007BFF] md:text-xl cursor-pointer relative "
          >
            {/* show what the use click else show state  */}
            {/* the page reflect when the drop down beside input is clicked */}
            <p className="w-[100%] capitalize font-workSans text-xs sm:text-xs md:text-lg whitespace-pre-wrap">
              {SearchStateValue ? SearchStateValue.substring(0, 5) : "Lagos"}
            </p>
            <i className="bi bi-chevron-down text-lg mt-2 cursor-pointer"></i>
          </div>
        </div>

        {/* <select
          name=""
          id=""
          className="w-20 border-0 outline-none focus:outline-0 text-[#007BFF]"
        >
          <option disabled value="state">
            state
          </option>
          <option value="">hello</option>
          <option value="">uiwoiw</option>
        </select> */}
      </div>
      <button
        type="submit"
        className="absolute right-0 top-0 mt-5 mr-4"
      ></button>
    </form>
  );
};

export default SearchBox;
